import ReportStatus from "../commons/model/report/ReportStatus";

export default class Report {
  uid: any;
  subject: any;
  creation: string;
  read: boolean;
}

export interface StatusInfo {
  status: ReportStatus;
  rejectionCause?: StatusRejectionCause;
}

export enum StatusRejectionCause {
  INCORRECT_VIEWS = "INCORRECT_VIEWS",
  MISSING_VIEWS = "MISSING_VIEWS",
  POOR_QUALITY = "POOR_QUALITY",
  APPLIANCES_NOT_REMOVED = "APPLIANCES_NOT_REMOVED",
  HIDDEN_TEETH = "HIDDEN_TEETH",
  PHOTO_WITHOUT_TEETH = "PHOTO_WITHOUT_TEETH",
  UNKNOWN = "UNKNOWN",
}

export enum StatusDocumentErrorType {
  NO_VISIBLE_MOUTH,
  MOUTH_OPENED,
  TOO_FEW_INPUT_TEETH,
  TOO_FEW_OUTPUT_TEETH,
  TOO_LOW_RESOLUTION,
  NO_FACE,
  CR_PRESENT,
  NO_INPUT_TEETH,
  NON_FULLFACE,
  HEAD_POSITION,
  ADJUST_CAMERA_DISTANCE,
  NOT_ENOUGH_TEETH_MAX,
  NOT_ENOUGH_TEETH_MAND,
  NOT_ENOUGH_TEETH,
  UNMAPPED_COMPUTE_ERROR,
  UNKNOWN,
}

export interface VirtualConsultationConfiguration {
  smileSimulation: boolean;
  smileAssessment: boolean;
  autoStart: boolean;
}

export interface ReportCreationRequest {
  virtualConsultationConfiguration: VirtualConsultationConfiguration;
  contactInfoId: string;
}
